"use strict";
angular.module("planCommandMonitorCustomFuncComplieModule", [])
    .controller('planCommandMonitorCustomFuncComplieCtrl', ['$scope', 'modalDialog', 'trsHttpService','$rootScope','$modalInstance','itemData', '$state', "$stateParams", '$validation',
        function($scope, modalDialog, trsHttpService,$rootScope,$modalInstance,itemData, $state, $stateParams, $validation) {
            initData();
            initStatus();
            /**
             * [initData description:初始化数据]
             */
            function initData() {
                    requestData();
            }
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.status = {
                    id: '',
                    modelTitle: '添加'
                };
                $scope.data = {
                    title: '',
                    url: '',
                };
                if (angular.isDefined(itemData.datas)) {
                    $scope.status.id = itemData.datas.id;
                    $scope.status.modelTitle = itemData.datas.id ? "编辑" : "添加";
                    $scope.data.title = itemData.datas.title;
                    $scope.data.url = itemData.datas.url;
                }

            }
            /**监听url地址的格式要求*/
            $scope.$watch('data.url', function() {
                var reg = new RegExp("^((http|https):\/\/)");
                $scope.regJug = reg.test($scope.data.url);
            });
            /**
             * [requestData description:请求数据]
             * @return {[type]} [description]
             */
            function requestData() {

            }
            /**
             * [saveMgr description:保存添加的设置]
             * @return {[type]} [description]
             */
            $scope.saveMgr = function() {
                $validation.validate($scope.customFuncCompile).success(function() {
                    if ($scope.regJug) {
                        modalDialog.confirmModal('提示信息', '确定保存吗?', function() {
                            var saveParams = {
                                "serviceid": 'mlf_bigdatascreen',
                                "methodname": 'queryDataFromBigScreen',
                                "modalname": 'customFuncMgr',
                                "method": 'save',
                                "title": $scope.data.title,
                                "url": $scope.data.url,
                                "id": $scope.status.id
                            };
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), saveParams, 'post').then(function(data) {
                                $rootScope.$broadcast('customFunc', true);
                                $modalInstance.close();
                            });
                        }, function() {});
                    } else {
                        modalDialog.alertType('', '请填写完整地址包含http!','info','confirm', function() {});
                    }
                }).error(function() {
                    modalDialog.alertType('', '请填写完整的信息','info','confirm', function() {});
                });

            };
            $scope.cancel=function(){
                $modalInstance.dismiss();
            };
            $scope.close=function(){
                $modalInstance.dismiss();
            };
        }
    ]);